export default {
  mask: {
    preview: {
      luminance: "Luminance Mask Preview",
      rgb: "RGB Mask Preview",
      dialogTitle: "Mask Preview",
    },
    tabs: {
      luminance: "Luminance",
      rgb: "RGB",
    },
    channels: {
      rgb: "RGB",
      r: "R",
      g: "G",
      b: "B",
    },
    controls: {
      channel: "Channel",
      zone: "Zone",
      fineTune: "Toggle Fine Tune",
      fineTuneShow: "Fine Tune",
      fineTuneHide: "Hide Fine Tune",
      hideMapping: "Hide Mapping",
      showMapping: "Show Mapping",
      showOriginal: "Show Original",
      showGray: "Show Gray Image",
      showLegend: "Show Legend",
      renderMode: "Toggle Render Mode",
      renderModeWebgl: "WebGL (GPU)",
      renderModeCanvas: "Canvas 2D (CPU)",
      renderModeSwitch: "Click to switch",
      showLabStats: "LAB statistics",
      showHslStats: "HSL statistics",
    },
    loadingPreview: "Loading preview",
    retry: "Retry",
    retryButton: "Retry",
    previewMappingFailed: "The mapping preview for the current image failed. Please try again later.",
    zone: {
      global: "Global",
      blacks: "Blacks",
      shadows: "Shadows",
      midtones: "Midtones",
      highlights: "Highlights",
      whites: "Whites",
    },
    clipping: {
      title: "Clipping",
      band: {
        hard: "Hard",
        near: "Near",
      },
      side: {
        left: "Shadow side",
        right: "Highlight side",
      },
    },
    legend: {
      red: "Red Channel",
      green: "Green Channel",
      blue: "Blue Channel",
      twoChannels: "Two Channels",
      allChannels: "All Channels",
      solidColor: "Solid Color",
      redGreen: "Red + Green",
      redBlue: "Red + Blue",
      greenBlue: "Green + Blue",
    },
    slider: {
      slice: "Slice",
      range: "Range",
      sliderMode: "Slider Mode",
    },
  },
  hover: {
    rgb: "RGB",
    luminance: "Luminance",
    placeholder: {
      title: "Point Inspector Preview",
      description:
        "Unlock to inspect exact RGB / LAB / HSL values at the current cursor position.",
      locked: "Locked",
      secondaryTitle: "Additional Color Spaces",
    },
    channel: {
      r: "R:",
      g: "G:",
      b: "B:",
      l: "L:",
    },
    hslHueWithName: "{value} ({name})",
  },
  region: {
    previewTitle: "Region Mask Preview",
    controls: {
      region: "Region",
    },
    options: {
      foreground: "Foreground",
      background: "Background",
    },
  },
  zone: {
    global: "Global Analysis",
    zoneAnalysisTitle: "{zone} Analysis",
    loading: "Loading analysis",
  },
  lab: {
    dialogTitle: "LAB Statistics - {zone}",
    toggleEn: "EN",
    toggleZh: "中",
    download: "Download statistics",
    loadingAnalysis: "Loading analysis",
    loadingStatistics: "Loading statistics",
    empty: "No statistics available for this zone",
    zone: {
      analysis: "Analysis",
      global: "Global",
      blacks: "Blacks",
      shadows: "Shadows",
      midtones: "Midtones",
      highlights: "Highlights",
      whites: "Whites",
    },
    metric: {
      title: "Metric",
      channel: "{channel} Channel",
      mean: "Mean",
      median: "Median",
      mode: "Mode",
      min: "Minimum",
      max: "Maximum",
      q1: "Q1 (25%)",
      q3: "Q3 (75%)",
      std: "Std Dev",
      variance: "Variance",
      skewness: "Skewness",
      kurtosis: "Kurtosis",
    },
    section: {
      overall: "Overall Conclusion",
      global: "Global Analysis",
      partition: "Partition Analysis",
    },
  },
  boxplot: {
    legend: {
      whisker: "Top whisker / Bottom whisker",
      box: "Box upper edge / Box lower edge",
      median: "Median line",
      mean: "Mean cross",
    },
  },
  hsl: {
    dialogTitle: "HSL Statistics - {zone}",
    download: "Download statistics",
    loadingStatistics: "Loading statistics",
    empty: "No statistics available for this zone",
    zone: {
      global: "Global",
      blacks: "Blacks",
      shadows: "Shadows",
      midtones: "Midtones",
      highlights: "Highlights",
      whites: "Whites",
    },
    metric: {
      title: "Metric",
      channel: "{channel} Channel",
      mean: "Mean",
      median: "Median",
      mode: "Mode",
      min: "Minimum",
      max: "Maximum",
      q1: "Q1 (25%)",
      q3: "Q3 (75%)",
      std: "Std Dev",
      variance: "Variance",
      skewness: "Skewness",
      kurtosis: "Kurtosis",
    },
  },
  ai: {
    loading: "Analyzing image...",
    errorPrefix: "Analysis failed:",
    errorPrefixZh: "分析失败:",
  },
  histogram: {
    title: {
      rgb: "RGB Distribution",
      tonal: "Tonal Distribution",
    },
    exportFile: "histogram_distribution.json",
    headers: {
      zone: "Zone",
      sum: "Sum",
      prop: "Prop",
      avg: "Avg",
    },
    average: "Average",
    pixels: "Pixels",
    tab: {
      rgb: "RGB",
      red: "Red",
      green: "Green",
      blue: "Blue",
      gray: "Gray",
      luminosity: "Luminosity",
    },
    span: {
      short: "Short",
      mid: "Mid",
      long: "Long",
    },
  },
  chart: {
    defaultTitle: "Tonal Histogram",
    loading: "Loading chart",
    title: {
      rgbHistogram: "RGB Histogram",
      rgbOverlay: "RGB Channels Overlay",
      redChannel: "Red Channel",
      greenChannel: "Green Channel",
      blueChannel: "Blue Channel",
      gray: "Gray",
      luminosity: "Luminosity",
      brightness: "Brightness ( HSV )",
      lightness: "Lightness ( LAB )",
    },
    description: {
      gray: "A standard monochrome projection balancing RGB channels. It offers a classic tonal distribution, making it ideal for analyzing compositional structure, negative space, and tonal values in black-and-white photography without color distractions.",
      luminosity:
        "The gold standard for exposure assessment, mirroring human vision by weighting green heavily and blue lightly. Crucial for verifying true perceived clipping and matching raw adjustments to actual visual experience.",
      brightness:
        "A purely mathematical representation based on the maximum color channel, highly responsive to vivid hues. Excellent for targeting specific color ranges and isolating vibrant tones for HSL adjustments rather than evaluating overall exposure.",
      lightness:
        "A perceptually uniform scale that decouples brightness from color. Perfect for high-end contrast adjustments and tone-curve edits, allowing you to manipulate highlights and shadows without inducing color shifts or artificial oversaturation.",
    },
    legend: {
      red: "R Channel",
      green: "G Channel",
      blue: "B Channel",
    },
    axis: {
      intensity: "Intensity Level",
      frequency: "Frequency",
    },
    controls: {
      reset: "Reset",
      toggleChannels: "Toggle channels",
    },
  },
  palette: {
    tabs: {
      global: "Global",
    },
    labels: {
      hex: "HEX",
      rgb: "RGB",
    },
    distribution: {
      hue: "Hue Distribution",
      saturation: "Saturation Distribution",
      lightness: "Lightness Distribution",
    },
    harmony: {
      title: "Color Harmony",
      wheel: "Harmony Wheel",
      legendDots: "Dots = dominant hues, size shows priority.",
      legendLines: "Dashed lines show hue relationships.",
      typeLabel: "Type:",
      relationshipsLabel: "Relationships:",
      distributionLabel: "Distribution:",
      types: {
        complementary: "Complementary",
        triadic: "Triadic",
        analogous: "Analogous",
        splitComplementary: "Split Complementary",
        tetradic: "Tetradic",
        square: "Square",
        monochrome: "Monochrome",
        neutral: "Neutral",
        custom: "Custom",
      },
      summaries: {
        complementary: "Opposite hues for crisp, energetic contrast.",
        triadic: "Three evenly spaced hues for lively balance.",
        analogous: "Neighbor hues for smooth, cohesive flow.",
        splitComplementary: "Balanced contrast with softer tension.",
        tetradic: "Two complementary pairs for rich variety.",
        square: "Four evenly spaced hues with bold diversity.",
        monochrome: "Single hue family with subtle shifts.",
        neutral: "Low saturation, calm and understated.",
        custom: "No dominant harmony structure; hues are mixed or dispersed.",
      },
      descriptions: {
        customStrong:
          "Harmony is strong, but no classic geometry dominates the palette.",
        customBalanced:
          "Balanced palette with no clear harmony geometry; adjust if needed.",
        customWeak:
          "Mixed hues with uneven structure; refine if you want a clearer harmony.",
        strong: "Excellent color harmony with balanced relationships.",
        good: "Good color harmony, minor adjustments recommended.",
        weak: "Color harmony needs improvement for better visual balance.",
      },
    },
    hueRanges: {
      red: "Red",
      orange: "Orange",
      yellow: "Yellow",
      yellowGreen: "Yellow-Green",
      green: "Green",
      greenCyan: "Green-Cyan",
      cyan: "Cyan",
      cyanBlue: "Cyan-Blue",
      blue: "Blue",
      blueMagenta: "Blue-Magenta",
      magenta: "Magenta",
      magentaRed: "Magenta-Red",
    },
    saturationRanges: {
      low: "Low",
      mediumLow: "Medium-Low",
      medium: "Medium",
      mediumHigh: "Medium-High",
      high: "High",
    },
    lightnessRanges: {
      veryDark: "Very Dark",
      dark: "Dark",
      medium: "Medium",
      light: "Light",
      veryLight: "Very Light",
    },
    statistics: {
      title: "Global Statistics",
      colorCount: "Color Count",
      mainColorProportion: "Main Color Proportion",
      colorfulness: "Colorfulness",
      averageSaturation: "Average Saturation",
      averageLightness: "Average Lightness",
      contrastRatio: "Contrast Ratio",
    },
    empty: "No color data available",
    copied: "Copied",
  },
};
